import React from "react";
import {Row, FormControl} from "react-bootstrap";
import {translate} from '../../i18n/translate.js';

export default class LoginInput extends React.Component {
    constructor(props) {
        super(props);
    }
    update(event) {
        this.props.update(event.target.value);
    }
    render() {
        const styleClass = !this.props.error? "sign-in-email":"sign-in-email error";
        return (
            <Row className="sign-in-email-row">
                <FormControl id={this.props.id} className={styleClass + " _lr-hide"} type={this.props.type} value={this.props.value} placeholder={translate(this.props.placeholder)}
                       onChange={this.update.bind(this)} ref="inp"/>
                {
                    this.props.error?
                        <div><label className="validation-error">{translate(this.props.error)}</label></div>
                        : undefined
                }
            </Row>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/login/LoginInputField.js